/*
 * File: AppNavigation.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:52 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: May 17, 2024 at 3:10 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Padding } from '../Padding';
import { Sidebar } from './Sidebar';

// Constants
import { AppNavSidebarWidth, mobileBreakpoint } from '../../styles/constants';


/**
 * Styles
 */

export const Navigation = styled.div`
	display: flex;
	height: auto !important;
	min-height: 100%;
	flex-direction: row;
`;

export const Wrapper = styled.div`
	display: flex;
	overflow: hidden;
	height: 100%;
	flex-grow: 1;
`;

export const DesktopSidebar = styled(Sidebar)`
	left: ${({ $isOpen }) => ($isOpen ? '0' : `-${AppNavSidebarWidth}`)}px;
`;

export const AppWindow = styled.div`
	padding-left: 0px;
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;

	@media only screen and (min-width: ${mobileBreakpoint}em) {
		padding-left: ${({ $isSidebarOpen }) => (!$isSidebarOpen ? '0' : `${AppNavSidebarWidth}`)}px;
	}
`;

export const Content = styled.div`
	flex: 1;
  	display: flex;
	overflow: auto;
	overflow-x: hidden;
	padding-top: 0px;
	flex-direction: column;
`;

export const ContentPadding = styled(Padding)`
	display: flex;
	flex-grow: 1;
`;

export const NavigationOverlay = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 99999;
	overflow: hidden;
	pointer-events: ${({ isOpen }) => (isOpen ? 'all' : 'none')};

	.mobileSidebar {
		transition: left 0.6s;
		-webkit-transition: left 0.6s;
		-moz-transition: left 0.6s;
		-o-transition: left 0.6s;
		left: ${({ isOpen }) => (isOpen ? '0px' : `-${AppNavSidebarWidth}px`)};
		position: fixed;

		&::-webkit-scrollbar {
			display: none;
		}
	}
`;

export const Overlay = styled.div`
	background-color: black;
	opacity: ${({ isOpen }) => (isOpen ? 0.6 : 0)};
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0px;
	transition: all 0.3s;
	-webkit-transition: all 0.3s;
	-moz-transition: all 0.3s;
	-o-transition: all 0.3s;
`;
